import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Ciclos, CiclosResponse } from "@p-p-portafolio/promociones/interfaces/ciclos";
import { EntityOperationResult } from "@shared/interfaces/responses/entity-operation-result";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class CiclosService {
    private baseUrl = environment.apiBaseUrl + "api/promociones/ciclos";

    constructor(private http: HttpClient) {}

    getAll(promocion: string) {
        const payload = {
            sUsuario: sessionStorage.getItem("Usser"),
            sPromocion: promocion,
            iCiclo: 0,
            iAccion: 4, //Valor para get
        };
        const url = `${environment.apiBaseUrl}api/Ciclospromocion/GetCiclosProm`;
        return this.http.post<CiclosResponse[]>(url, payload);
    }

    add(promocion: string, iCiclo: number) {
        const payload = {
            sUsuario: sessionStorage.getItem("Usser"),
            sPromocion: promocion,
            iCiclo: iCiclo,
            iAccion: 0, //0: Agrega 1: Consulta 3: Borrar 4: Lista
        };
        const url = `${environment.apiBaseUrl}api/Ciclospromocion/SetCiclosProm`;
        return this.http.post<any>(url, payload);
    }

    delete(promocion: string, iCiclo: number) {
        const payload = {
            sUsuario: sessionStorage.getItem("Usser"),
            sPromocion: promocion,
            iCiclo: iCiclo,
            iAccion: 3, //0: Agrega 1: Consulta 3: Borrar 4: Lista
        };
        const url = `${environment.apiBaseUrl}api/Ciclospromocion/SetCiclosProm`;
        return this.http.post<any>(url, payload);
    }
}
